<template>
  <div class="wrapper help-workpanel">
    <transition name="fade">
      <div class="panel" v-show="content.show">
        <div class="header">
          <div class="title">
            <p
              style="
                font-family: 'Izhitsa Cyrillic', sans-serif;
                color: red;
                font-size: 140%;
              "
            >
              {{ content.head }}
            </p>
          </div>
          <div class="row content">
            <div class="col-sm-6">
              <label>Районы</label>
              <small
                style="float: right; color: #999; top: 3px; position: relative"
                >Отобрано: {{ $store.state.regions.termsFilteredCount }}</small
              >
              <region-select />
              <label>Категории</label>
              <small
                style="float: right; color: #999; top: 3px; position: relative"
                >Отобрано:
                {{ $store.state.categories.termsFilteredCount }}</small
              >
              <category-select />
            </div>
            <div class="col-sm-6">
              <label>Слова</label>
              <small
                style="float: right; color: #999; top: 3px; position: relative"
                >Отобрано: {{ $store.getters.termfilter.length }}</small
              >
              <terms-list />
            </div>
          </div>
        </div>
        <span
          class="at-modal__close"
          @click="$emit('close')"
          style="top: 6px; right: 6px; font-size: 30px"
        >
          <i class="icon icon-x"></i>
        </span>
      </div>
    </transition>
  </div>
</template>

<script>
import RegionSelect from "./RegionSelect.vue";
import CategorySelect from "./CategorySelect.vue";
import TermsList from "./TermsList.vue";

export default {
  components: {
    RegionSelect,
    CategorySelect,
    TermsList,
  },
  props: ["content"],
};
</script>

<style scoped>
p {
  margin-bottom: 0;
}

.wrapper {
  left: 8px;
  top: 10px;
  outline: 0;
  position: absolute;
  width: fit-content;
  z-index: 100000;
}

.panel {
  position: relative;
  margin: 0 auto;
  border-radius: 4px;
  background-color: #fff;
  outline: none;
  width: 450px;
  max-width: 100vw;
  left: 0px;
  top: 0px;
  height: 100%;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 5px 10px;
  border: 1px solid rgba(0, 0, 0, 0.2);
}

.header {
  padding: 12px 16px;
  color: #2c405a;
  font-size: 14px;
  line-height: 1.5;
  border-bottom: 1px solid #ececec;
}

.close {
  position: absolute;
  top: 16px;
  right: 16px;
  font-size: 13px;
  line-height: 1;
  overflow: hidden;
  cursor: pointer;
}

.myclose {
  position: absolute;
  padding: 7px;
  border-radius: 10px;
  background: #dc3545;
  color: white;
  top: -5px;
  right: -5px;
  font-size: 13px;
  line-height: 1;
  overflow: hidden;
  cursor: pointer;
}

.at-table {
  margin: -17px;
}

.group-icon {
  width: 20px;
  height: 20px;
  border: 1px solid #777;
  border-radius: 10px;
}

@media (max-width: 576px) {
  .wrapper {
    left: 0;
    top: 0;
    z-index: 10;
  }

  .myclose {
    top: 62px;
    left: 365px;
    right: auto;
    position: fixed;
  }
}

@media (max-width: 450px) {
  .myclose {
    top: 62px;
    right: 6px;
    left: auto;
    position: fixed;
  }
}
</style>
